module.exports = __webpack_public_path__ + "img/monthly-budget-planner_B09QNCXZF8.5c5d3a8d.jpg";